export default {
  state: {
    addQuestion: false,
    actName: null
  },
  mutations: {
    addQuestionBtn (state, val) {
      state.addQuestion = val
    },
    // 改变选中名称
    selectActName (state, val) {
      state.actName = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/test.js